/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


/* ============================================================
   FORCE HEADER COMPRESS BREAKPOINT
   - Desktop above 1200px
   - Compressed/mobile at 1200px and below
   ============================================================ */

  'use strict';

  var BREAKPOINT = 1200;
  var HEADER_SELECTOR = '[data-site-header]';
  var COMPRESS_CLASS = 'site-header--compress';
  var observer = null;
  var ticking = false;

  function getHeader() {
    return document.querySelector(HEADER_SELECTOR);
  }

  function enforceHeaderBreakpoint() {
    var header = getHeader();
    if (!header) return;

    var shouldCompress = window.innerWidth <= BREAKPOINT;
    var isCompressed = header.classList.contains(COMPRESS_CLASS);

    if (shouldCompress && !isCompressed) {
      header.classList.add(COMPRESS_CLASS);
    }

    if (!shouldCompress && isCompressed) {
      header.classList.remove(COMPRESS_CLASS);
    }
  }

  function requestEnforce() {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(function () {
      enforceHeaderBreakpoint();
      ticking = false;
    });
  }

  function initForcedHeaderBreakpoint() {
    var header = getHeader();

    enforceHeaderBreakpoint();

    if (header && !observer) {
      observer = new MutationObserver(function () {
        requestEnforce();
      });

      observer.observe(header, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initForcedHeaderBreakpoint);
  document.addEventListener('theme:resize', requestEnforce);
  document.addEventListener('theme:resize:width', requestEnforce);
  window.addEventListener('resize', requestEnforce);
  window.addEventListener('load', initForcedHeaderBreakpoint);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
